import { render, staticRenderFns } from "./PesquisaMensagemVetoMunicipalShow.vue?vue&type=template&id=32339f98&scoped=true"
import script from "./PesquisaMensagemVetoMunicipalShow.vue?vue&type=script&lang=js"
export * from "./PesquisaMensagemVetoMunicipalShow.vue?vue&type=script&lang=js"
import style0 from "./PesquisaMensagemVetoMunicipalShow.vue?vue&type=style&index=0&id=32339f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32339f98",
  null
  
)

export default component.exports